import { useNavigate } from "react-router-dom";
import { products } from "@/mocks/products";

const FeaturedProducts = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-amber-50">
      <div className="max-w-screen-xl mx-auto px-4 md:px-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-4">
          <div>
            <p className="text-amber-500 text-xs font-semibold uppercase tracking-widest mb-2">Hot Products</p>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900" style={{ fontFamily: "'Playfair Display', serif" }}>
              Featured Products
            </h2>
          </div>
          <button
            onClick={() => navigate("/products")}
            className="text-amber-600 hover:text-amber-700 text-sm font-semibold flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            View All Products <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-product-shop>
          {products.slice(0, 6).map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-2xl overflow-hidden hover:-translate-y-1 transition-transform duration-300 cursor-pointer group"
              onClick={() => navigate(`/products/${product.id}`)}
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 flex gap-2">
                  {product.verified && (
                    <span className="bg-amber-500 text-white text-xs font-bold px-2 py-1 rounded-md flex items-center gap-1">
                      <i className="ri-shield-check-line"></i> Verified
                    </span>
                  )}
                  {product.dropshipping && (
                    <span className="bg-emerald-500 text-white text-xs font-bold px-2 py-1 rounded-md flex items-center gap-1">
                      <i className="ri-truck-line"></i> Dropship
                    </span>
                  )}
                </div>
                <div className="absolute bottom-3 right-3 bg-white/90 text-xs text-gray-600 px-2 py-1 rounded-md">
                  {product.country}
                </div>
              </div>
              <div className="p-5">
                <p className="text-xs text-amber-600 font-medium mb-1">{product.supplierName}</p>
                <h3 className="font-semibold text-gray-900 text-sm mb-2 line-clamp-2">{product.name}</h3>
                <div className="flex items-center gap-1 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className={`ri-star-fill text-xs ${i < Math.floor(product.rating) ? "text-amber-400" : "text-gray-200"}`}></i>
                  ))}
                  <span className="text-xs text-gray-400 ml-1">({product.reviews})</span>
                </div>
                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-lg font-bold text-gray-900">${product.price.min}</span>
                    <span className="text-gray-400 text-sm"> - ${product.price.max}</span>
                    <div className="text-xs text-gray-400">MOQ: {product.moq} pcs</div>
                  </div>
                  <button
                    onClick={(e) => { e.stopPropagation(); navigate(`/products/${product.id}`); }}
                    className="border border-amber-400 text-amber-600 hover:bg-amber-500 hover:text-white text-xs font-semibold px-3 py-2 rounded-md transition-colors whitespace-nowrap cursor-pointer"
                  >
                    View
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
